import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGlobalLoaderStore = defineStore('globalLoader', () => {
  const loading = ref<boolean>(false);
  const isSideNavLoading = ref<boolean>(false);

  const showLoader = () => {
    loading.value = true;
  };
  const hideLoader = () => {
    loading.value = false;
  };
  const showSideNavLoader = () => {
    isSideNavLoading.value = true;
  };
  const hideSideNavLoader = () => {
    isSideNavLoading.value = false;
  };

  return {
    loading,
    showLoader,
    hideLoader,
    isSideNavLoading,
    showSideNavLoader,
    hideSideNavLoader,
  };
});
